var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-config-page" },
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _vm._m(0),
          _c(
            "el-button",
            {
              staticClass: "btn-add",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.openCreateDialog },
            },
            [_vm._v("Thêm mới")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-select",
            {
              staticClass: "status-filter",
              attrs: { placeholder: "Tất cả trạng thái" },
              on: { change: _vm.handleStatusFilterChange },
              model: {
                value: _vm.searchParams.isActive,
                callback: function ($$v) {
                  _vm.$set(_vm.searchParams, "isActive", $$v)
                },
                expression: "searchParams.isActive",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "Đang hoạt động", value: true },
              }),
              _c("el-option", {
                attrs: { label: "Ngừng hoạt động", value: false },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-content row-data" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                "element-loading-text": _vm.$tableLoading,
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0)",
                data: _vm.tableData,
                "highlight-current-row": "",
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": _vm.$tableMaxHeight,
                "empty-text": _vm.textTable,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "configKey", label: "Config Key", width: "200" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "groupName",
                  label: "Nhóm",
                  width: "200",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "mediaType",
                  label: "Loại media",
                  width: "110",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.mediaTypeTagType(scope.row.mediaType),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.mediaType) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "configValue",
                  label: "Giá trị",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderPriority",
                  label: "Thứ tự",
                  width: "90",
                  align: "center",
                  sortable: "",
                  "sort-method": _vm.sortByOrderPriority,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Trạng thái", width: "130", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.active ? "success" : "danger",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.active ? "Hoạt động" : "Ngừng"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  align: "center",
                  fixed: "right",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openUpdateDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("Sửa")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("Xóa")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrap" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next",
              total: _vm.totalItems,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.searchParams.limit,
              "current-page": _vm.searchParams.page,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
      _c("CreateLoginConfigDialog", {
        attrs: { visible: _vm.isCreateVisible },
        on: { close: _vm.handleCloseCreate },
      }),
      _c("UpdateLoginConfigDialog", {
        attrs: { visible: _vm.isUpdateVisible, item: _vm.selectedItem },
        on: { close: _vm.handleCloseUpdate },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-wrap" }, [
      _c("h3", { staticClass: "page-title" }, [
        _vm._v("Cấu hình trang đăng nhập"),
      ]),
      _c("p", { staticClass: "page-subtitle" }, [
        _vm._v(
          "Quản lý danh sách cấu hình hiển thị ảnh video trên trang đăng nhập"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }